import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { HiCreditCard, HiHome } from "react-icons/hi2";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import DashboardSideNavContent from "../components/dashboard/DashboardSideNavContent";

const drawerWidth = 280;
const desktopDrawerWidth = 250;

const navItems = [
  { label: "Dashboard", link: "/affiliate/dashboard", icon: HiHome, end: true },
  {
    label: "Billing Information",
    link: "/affiliate/billing-information",
    icon: HiCreditCard,
  },
];

function AffiliateSideNav({ window, mobileOpen, handleDrawerToggle }) {
  const { profiledata } = useIndexPageData();
  const container =
    window !== undefined ? () => window().document.body : undefined;

  const drawerPaperStyles = {
    boxSizing: "border-box",
    border: "none",
    bgcolor: "#151821",
    color: "#fff",
    overflow: "hidden",
    zIndex: { md: 900, xs: 1201 },
  };

  const renderDrawer = (isMobile) => (
    <DashboardSideNavContent
      title="Affiliate Hub"
      subtitle="Partner workspace"
      switchLink={{ to: "/user/dashboard", label: "Go to User Dashboard" }}
      navItems={navItems}
      profiledata={profiledata}
      isMobile={isMobile}
      onClose={handleDrawerToggle}
    />
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: desktopDrawerWidth }, flexShrink: { md: 0 } }}
      aria-label="Affiliate dashboard navigation"
    >
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            ...drawerPaperStyles,
            width: drawerWidth,
            maxWidth: "88vw",
          },
        }}
      >
        {renderDrawer(true)}
      </Drawer>
      <Drawer
        variant="permanent"
        open
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": { ...drawerPaperStyles, width: desktopDrawerWidth },
        }}
      >
        {renderDrawer(false)}
      </Drawer>
    </Box>
  );
}

AffiliateSideNav.propTypes = {
  window: PropTypes.func,
  mobileOpen: PropTypes.bool,
  handleDrawerToggle: PropTypes.func.isRequired,
};

export default AffiliateSideNav;
